import React from 'react'
import './Experience.css'

export default function experience(props) {
  return (
    <div className='experience'>
      <div className='archievement'>
        <span className='circle'>2+</span>
        <span>Years</span>
        <span>Experience</span>
      </div>
      <div className='archievement'>
        <span className='circle'>2+</span>
        <span>Years</span>
        <span>Experience</span>
      </div>
      <div className='archievement'>
        <span className='circle'>2+</span>
        <span>Years</span>
        <span>Experience</span>
      </div>
    </div>
  )
}
